import { render } from "./VisitsSummary.vue?vue&type=template&id=008a8163&scoped=true"
import script from "./VisitsSummary.vue?vue&type=script&lang=js"
export * from "./VisitsSummary.vue?vue&type=script&lang=js"

import "./VisitsSummary.vue?vue&type=style&index=0&id=008a8163&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008a8163"]])

export default __exports__